import { memo } from "react";
import { Check, CheckCheck } from "lucide-react";

interface ReadReceiptProps {
  isRead: boolean;
  isSent?: boolean;
}

const ReadReceipt = memo(({ isRead, isSent = true }: ReadReceiptProps) => {
  if (!isSent) return null;

  return (
    <span className="inline-flex items-center ml-1">
      {isRead ? (
        <CheckCheck className="w-3.5 h-3.5 text-sky-400" />
      ) : (
        <Check className="w-3.5 h-3.5 text-white/50" />
      )}
    </span>
  );
});

ReadReceipt.displayName = "ReadReceipt";

export default ReadReceipt;
